import type React from 'react';
import { useTranslation } from 'react-i18next';
import type { DefaultTheme } from 'styled-components';
import { useTheme } from 'styled-components';

import type { SalesPromotionDto } from '@/services/ws-funnel/src/main/resources/rest-api';
import { SalesPromotionPhase } from '@/services/ws-funnel/src/main/resources/rest-api';
import { Tag } from '@/js/libs/ui';

interface PromotionPhaseTagProps {
  promotion: SalesPromotionDto;
  className?: string;
}

export const getTagColor = (phase: SalesPromotionPhase, theme: DefaultTheme) => {
  switch (phase) {
    case SalesPromotionPhase.CANCELED:
      return theme.colors.critical100;
    case SalesPromotionPhase.FINISHED || SalesPromotionPhase.INACTIVE:
      return theme.colors.grey70_1;
    case SalesPromotionPhase.PLANNED:
      return theme.colors.main;
    case SalesPromotionPhase.RUNNING:
      return theme.colors.positive100;
    default:
      return undefined;
  }
};

export const PromotionPhaseTag: React.FC<PromotionPhaseTagProps> = ({ promotion, className }) => {
  const theme = useTheme();
  const [t] = useTranslation(['backend']);

  if (promotion.phase) {
    return <Tag color={getTagColor(promotion.phase, theme)} className={className} value={t(promotion.phase)} />;
  }
  return null;
};
